import { createNavigationContainerRef } from '@react-navigation/native';
/**
 * Shared ref for the root NavigationContainer (see App.tsx).
 * Used when a screen must navigate after auth changes that swap App vs Guest navigators.
 */
export const rootNavigationRef = createNavigationContainerRef();
